/**
 * @flow
 * @relayHash 8ee6f7c739a7cec7d27782a79fbca48c
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type UpdateViewerAvatarModal_user$ref = any;
type UserAvatar_user$ref = any;
export type CompanyUserRole = "ADMIN" | "SUPERUSER" | "USER" | "WORKER";
export type ProfileQueryVariables = {||};
export type ProfileQueryResponse = {|
  +viewer: ?{|
    +id: string,
    +avatar: ?string,
    +firstName: string,
    +lastName: string,
    +email: any,
    +ssoProvider: ?string,
    +role: CompanyUserRole,
    +phone: ?string,
    +phoneVerified: boolean,
    +twoFactorEnabled: boolean,
    +company: {|
      +id: string,
      +timezone: ?string,
      +addressLine1: ?string,
      +addressLine2: ?string,
      +addressCity: ?string,
      +addressState: ?string,
      +addressZip: ?string,
      +addressCountry: ?string,
      +phone: ?string,
    |},
    +$fragmentRefs: UserAvatar_user$ref & UpdateViewerAvatarModal_user$ref,
  |}
|};
export type ProfileQuery = {|
  variables: ProfileQueryVariables,
  response: ProfileQueryResponse,
|};
*/


/*
query ProfileQuery {
  viewer {
    id
    avatar
    firstName
    lastName
    email
    ssoProvider
    role
    phone
    phoneVerified
    twoFactorEnabled
    company {
      id
      timezone
      addressLine1
      addressLine2
      addressCity
      addressState
      addressZip
      addressCountry
      phone
    }
    ...UserAvatar_user
    ...UpdateViewerAvatarModal_user
  }
}

fragment UserAvatar_user on User {
  id
  avatar
  firstName
}

fragment UpdateViewerAvatarModal_user on User {
  id
  avatar
  firstName
  ...UserAvatar_user
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "avatar",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "firstName",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "lastName",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "email",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "ssoProvider",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "role",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "phone",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "phoneVerified",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "twoFactorEnabled",
  "args": null,
  "storageKey": null
},
v10 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "company",
  "storageKey": null,
  "args": null,
  "concreteType": "Company",
  "plural": false,
  "selections": [
    (v0/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "timezone",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "addressLine1",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "addressLine2",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "addressCity",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "addressState",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "addressZip",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "addressCountry",
      "args": null,
      "storageKey": null
    },
    (v7/*: any*/)
  ]
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "ProfileQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          {
            "kind": "FragmentSpread",
            "name": "UserAvatar_user",
            "args": null
          },
          {
            "kind": "FragmentSpread",
            "name": "UpdateViewerAvatarModal_user",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "ProfileQuery",
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "ProfileQuery",
    "id": null,
    "text": "query ProfileQuery {\n  viewer {\n    id\n    avatar\n    firstName\n    lastName\n    email\n    ssoProvider\n    role\n    phone\n    phoneVerified\n    twoFactorEnabled\n    company {\n      id\n      timezone\n      addressLine1\n      addressLine2\n      addressCity\n      addressState\n      addressZip\n      addressCountry\n      phone\n    }\n    ...UserAvatar_user\n    ...UpdateViewerAvatarModal_user\n  }\n}\n\nfragment UserAvatar_user on User {\n  id\n  avatar\n  firstName\n}\n\nfragment UpdateViewerAvatarModal_user on User {\n  id\n  avatar\n  firstName\n  ...UserAvatar_user\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'd7e66f7856670e211ce7fc49acdc57ca';
module.exports = node;
